import AnimeSeriesCard from "../../../components/animeSeriesCard/animeSeriesCard";
import RefCardsCarousel from "../../../components/refCardsCarousel/refCardsCarousel";

import styles from "./editorsChoiceCarousel.module.scss";

import { useStoryblokEditorsChoiceWidget } from "../../../hooks/useStoryblokEditorsChoiceWidget";
import StoryblokImageBasic from "../../../components/storyblokImageBasic/storyblokImageBasic";
import useMediaQuery from "../../../hooks/useMediaQuery";

import { OrangeHeartSVG, TealHeartSVG } from "../../../svg";
import { useCompressedImage } from "../../../components/storyblokImageBasic/helpers";

function EditorsChoiceCarousel({ blok }) {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const [series, isLoading] = useStoryblokEditorsChoiceWidget(blok.series);
  const backgroundFilename = isMobile ? blok.background_image_mobile.filename : blok.background_image.filename;
  const backgroundImageUrl = useCompressedImage(backgroundFilename);

  if (!isLoading && series.length === 0) {
    return null;
  }

  return (
    <div
      className={`${styles.root}`}
      style={{
        backgroundImage: `url('${backgroundImageUrl}')`,
        backgroundSize: "cover",
      }}
    >
      <div className={`${styles.container} view`}>
        <div className={styles.titleAndCarousel}>
          <h2 className={styles.title}>
            {blok.title}
            <div className={styles.orangeHeartSVG}>
              <OrangeHeartSVG />
            </div>
            <div className={styles.tealHeartSVG}>
              <TealHeartSVG />
            </div>
          </h2>
          <p className={styles.subtitle}>{blok.subtitle}</p>
          <div className={styles.carouselContainer}>
            {series && series.length ? (
              <RefCardsCarousel
                withClass={styles.carousel}
                desktopOptions={{ perPage: 4 }}
                tabletOptions={{ perPage: 5 }}
                smallTabletOptions={{ perPage: 4 }}
                mobileExtendedOptions={{ perPage: 3, gap: 10 }}
                mobileOptions={{ perPage: 2, gap: 10 }}
                extraSmallOptions={{ perPage: 2, gap: 10 }}
                arrowClass={styles.arrow}
              >
                {series.map((item) => (
                  <AnimeSeriesCard key={item.uuid} series={item} />
                ))}
              </RefCardsCarousel>
            ) : null}
          </div>
        </div>

        <div className={styles.rightImageContainer}>
          {blok.right_side_image ? (
            <StoryblokImageBasic
              image={blok.right_side_image}
              width={495}
              height={576}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default EditorsChoiceCarousel;
